import template from '../html/default-modal-notification-template.hbs'
import Modal from "./modal";

export default class Notification extends Modal {

    static createDefault(data) {
        return Modal.create(template(data));
    }

   /* static createFromContentString(content) {
        return Modal.createFromContentString(content);
    }*/
}



// WEBPACK FOOTER //
// ./app/general/js/notification.js